import { updateInventoryItem } from "../../api/inventoryService";

export const useUpdateInventoryItem = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateInventoryItem(id, data);
        if (successCallback) successCallback(updatedRecord);
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update inventory item:", error);
        throw error;
    }
  };

  return { update };
};